module.exports = __webpack_public_path__ + "static/media/mongo.f6898124.png";